import { render, staticRenderFns } from "./GetYao.vue?vue&type=template&id=99bc95e2&scoped=true&"
import script from "./GetYao.vue?vue&type=script&lang=js&"
export * from "./GetYao.vue?vue&type=script&lang=js&"
import style0 from "./GetYao.vue?vue&type=style&index=0&id=99bc95e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bc95e2",
  null
  
)

export default component.exports